import './utils/securityGuard';   // security: quiet console on the live site + password values never in page HTML (must stay FIRST)
import React from 'react';
import ReactDOM from 'react-dom/client';
import { hasSavedSession, isPublicLandingPath } from './utils/publicSession';
import './styles/globals.css';
import './styles/responsive.css';
import './styles/theme-dark.css';
import './styles/modern-ui.css';          // Interface style: Modern — scoped to html[data-ui="modern"]
import './styles/modern-dark.css';        // Modern + Dark theme — real dark palette (replaces the colour-flip for Modern)
import { applyUiMode } from './utils/uiMode';
import { installAlertDialog } from './components/ui/ConfirmDialog';
import { installTextClean } from './utils/uiTextClean';
applyUiMode();
installAlertDialog();   // window.alert → in-app message box (non-classic interface styles only)
installTextClean();     // decorative emoji hidden from labels / messages (non-classic styles only)

// -- ChunkLoadError recovery --------------------------------------------------
(function handleChunkError() {
  var RELOAD_KEY = 'barkah_chunk_reload';
  window.addEventListener('error', function(e) {
    var msg = e && (e.message || '');
    var isChunk = msg.indexOf('ChunkLoadError') !== -1
               || msg.indexOf('Loading chunk') !== -1
               || msg.indexOf('Loading CSS chunk') !== -1;
    if (!isChunk) return;
    var last = parseInt(sessionStorage.getItem(RELOAD_KEY) || '0', 10);
    if (Date.now() - last > 30000) {
      sessionStorage.setItem(RELOAD_KEY, String(Date.now()));
      window.location.reload();
    }
  }, true);
})();

// -- Ensure correct viewport meta for mobile ----------------------------------
(function ensureViewport() {
  let vm = document.querySelector('meta[name="viewport"]');
  if (!vm) {
    vm = document.createElement('meta');
    vm.name = 'viewport';
    document.head.appendChild(vm);
  }
  vm.content = 'width=device-width, initial-scale=1, maximum-scale=1, viewport-fit=cover';
})();

function patchDateInputs(root) {
  root.querySelectorAll('input[type="date"]').forEach(el => {
    if (!el.getAttribute('max')) el.setAttribute('max', '9999-12-31');
    if (!el.getAttribute('min')) el.setAttribute('min', '2000-01-01');
  });
}
const _observer = new MutationObserver(muts => {
  muts.forEach(m => m.addedNodes.forEach(n => {
    if (n.nodeType === 1) {
      if (n.matches?.('input[type="date"]')) {
        if (!n.getAttribute('max')) n.setAttribute('max', '9999-12-31');
        if (!n.getAttribute('min')) n.setAttribute('min', '2000-01-01');
      }
      patchDateInputs(n);
    }
  }));
});
_observer.observe(document.body || document.documentElement, { childList: true, subtree: true });
setTimeout(() => patchDateInputs(document.body), 500);

const root = ReactDOM.createRoot(document.getElementById('root'));

// Logged-out visitors on the website pages get the light landing bundle; everyone else the full ERP.
const _publicSite = isPublicLandingPath(window.location.pathname) && !hasSavedSession();
(_publicSite ? import('./PublicApp') : import('./FullApp'))
  .then(({ default: Root }) => root.render(React.createElement(Root)))
  .catch(() => {   // network hiccup while loading the bundle → one automatic retry
    const k = 'barkah_boot_reload', last = parseInt(sessionStorage.getItem(k) || '0', 10);
    if (Date.now() - last > 30000) { sessionStorage.setItem(k, String(Date.now())); window.location.reload(); }
  });
